import type { ReactNode } from 'react';
import { ChevronLeft } from '../../icons';
import './SecondaryPane.css';

/**
 * ② 좌측 상세 표준 껍데기 — 설계 §5-②.
 * docs/design/design-20260717-common-layout-skeleton.md
 *
 * 헤더(2차 타이틀 + 접기) → 검색(선택) → 목록 slot(트리/리스트/카드 자유). 목록 영역만 스크롤.
 * 기존 페이지 사이드바(CalendarSidebar/BoardSidebar 등)를 강제 이관하지 않는다 —
 * 신규/리팩터 시 본 껍데기에 목록만 주입하는 점진 수렴용.
 */
export interface SecondaryPaneProps {
  /** 메뉴 타이틀. */
  title: ReactNode;
  /** 헤더 하단 검색/필터 액세서리 (선택). */
  search?: ReactNode;
  /** 접기 버튼 핸들러 (선택). 미제공 시 버튼 미표시. */
  onCollapse?: () => void;
  /** 목록 slot. */
  children: ReactNode;
}

export function SecondaryPane({ title, search, onCollapse, children }: SecondaryPaneProps) {
  return (
    <div className="secondary-pane">
      <div className="secondary-pane__header">
        <div className="secondary-pane__title">{title}</div>
        {onCollapse && (
          <button
            type="button"
            className="secondary-pane__collapse"
            onClick={onCollapse}
            aria-label="패널 접기"
          >
            <ChevronLeft size={16} aria-hidden />
          </button>
        )}
      </div>
      {search != null && <div className="secondary-pane__search">{search}</div>}
      <div className="secondary-pane__list scrollbar-thin">{children}</div>
    </div>
  );
}
